import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { PopoverService } from 'app/core/services/popover.service';
import { PeerToPeerManageService } from 'app/manage-p2p/services/peer-to-peer-manage/peer-to-peer-manage.service';
import { MdbPopoverDirective, MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
import { Subject } from 'rxjs';
import * as _ from 'lodash';
import { CommonModule } from '@angular/common';

let id = 1;

@Component({
  standalone:true,
  selector: 'app-p2p-team-popover',
  templateUrl: './p2p-team-popover.component.html',
  styleUrl: './p2p-team-popover.component.scss',
  imports:[MdbPopoverModule,CommonModule]
})
export class P2pTeamPopoverComponent implements OnInit{

  @ViewChild('popover') popover: MdbPopoverDirective = null;

  @Input() fundraisers;
  @Input() teamName;

  public isTransactionsExist = true;
  public allTransactions = [];

  public userExelData = null;

  public takeUntilSubject: Subject<any> = new Subject();

  private _id = id++;
  get id() {
    return `P2PPopoverEvent_${this._id}`;
  }

  constructor(
    private popoverService: PopoverService,
    public peerToPeerManageService: PeerToPeerManageService,
  ) { }

  ngOnInit(): void {
    const allTransactions = _.flatten(_.map(this.fundraisers, 'transactions'));
    const sortedTransactions = _.sortBy(allTransactions, 'updated').reverse();

    this.allTransactions = sortedTransactions;
  }

  onClickNotify() {
    
  }

  onClickEdit() {

  }

  onClickExport () {
    this.userExelData = this.peerToPeerManageService.getUserExcelData(this.allTransactions);
    const fileName = `${this.teamName}_report`

    this.peerToPeerManageService.exportToExcel(this.userExelData, fileName)
  }

  onPopoverShown(): void {
    this.popoverService.list[this.id] = this.popover;
  }

  onPopoverHidden(): void {
    delete this.popoverService.list[this.id];
  }
}
